import React, { useState } from 'react';
import classNames from 'classnames';
import styles from '../assets/payroll-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import { QueryParams } from 'src/types/grid';
import { IPayroll } from 'src/types/payroll';
import PayrollsActionsColumn from './PayrollsActionsColumn';
import textFilter from '../../../../../../../components/react-table/filters/text-filter';
import { CellProps } from 'react-table';
import { Link } from 'react-router-dom';
import Router from '../../../../../../../navigation/router';
import { routes } from '../../../../../../../navigation';
import GeneralEnum from '../../../../../../../enumerables/general-enum';
import { getValFromEnum } from '../../../../../../../components/redux-form/utils/dropdown-values';
import dropdownFilter from '../../../../../../../components/react-table/filters/dropdown-filter';
import dateFilterMulti from '../../../../../../../components/react-table/filters/date-filter-multi';
import dateFilter from '../../../../../../../components/react-table/filters/date-filter';
import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';
import { numberWithCommas } from '../../../../../../../helpers/format';

interface Props {
    data: Paginated<IPayroll>;
    providers: SelectObject[];
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
    getDataInFile: (params: QueryParams) => void;
}
const generalEnum = GeneralEnum ? GeneralEnum.getEnum('PayrollStatus') : {};
const statusTypes: SelectObject[] = getValFromEnum(generalEnum);
const getColumns = (
    dataProd: SelectObject[],
    updateState: boolean,
    setUpdateState: (parm: boolean) => void,
): Column<IPayroll>[] => [
    {
        Header: 'Payroll ID',
        accessor: 'id',
        disableSortBy: true,
        Filter: textFilter<IPayroll>(),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IPayroll>) => (
            <Link
                className={'mr-1'}
                to={Router.generate(routes.PROVIDER_DETAIL, {
                    id: original?.provider?.id,
                    tab: 'payrolls-detail',
                    subId: original.id,
                })}
            >
                {original.id}
            </Link>
        ),
    },

    {
        Header: 'Provider',
        accessor: 'provider.id',
        disableSortBy: true,
        Filter: dropdownFilter<IPayroll>(dataProd),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IPayroll>) => {
            if (!original?.provider) return '';

            return (
                <Link
                    to={Router.generate(routes.PROVIDER_DETAIL, {
                        id: original?.provider?.id,
                        tab: 'main-info',
                        subId: '',
                    })}
                >
                    {original.provider?.fullName}
                </Link>
            );
        },
    },
    {
        Header: 'Employee ID',
        accessor: 'provider.employeeId',
        disableSortBy: true,
        Filter: textFilter<IPayroll>(),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IPayroll>) => {
            if (!original?.provider) return '';
            return original.provider?.employeeId;
        },
    },
    {
        Header: 'Payroll Date',
        accessor: 'payrollDate',
        disableSortBy: true,
        headerClassName: 'text-center w-100 d-block',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IPayroll>) => {
            return (
                <div className={'text-center'}>
                    {original.payrollDate ? changeToZeroMoment(original.payrollDate, 'MMM D, YYYY') : ''}
                </div>
            );
        },
        Filter: dateFilterMulti<IPayroll>(),
    },
    {
        Header: 'Total Payable',
        accessor: 'totalPaid',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IPayroll>) => {
            return original.totalPaid ? `$${numberWithCommas(original.totalPaid)}` : '$0';
        },
        Filter: textFilter<IPayroll>(),
    },
    {
        Header: 'Period Start',
        accessor: 'periodStart[after]',
        disableSortBy: true,
        Filter: dateFilter<IPayroll>(),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IPayroll>) => changeToZeroMoment(original.periodStart, 'MMM D, YYYY'),
    },
    {
        Header: 'Period End',
        accessor: 'periodEnd[before]',
        disableSortBy: true,
        Filter: dateFilter<IPayroll>(),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IPayroll>) => changeToZeroMoment(original.periodEnd, 'MMM D, YYYY'),
    },
    {
        Header: 'Note',
        disableSortBy: true,
        disableFilters: true,
        accessor: 'note',
        Filter: textFilter<IPayroll>(),
    },
    {
        Header: 'Hours',
        disableSortBy: true,
        disableFilters: true,
        accessor: 'hoursAdminAndConfirm',
        Filter: textFilter<IPayroll>(),
    },
    /* {
        Header: 'Total',
        disableSortBy: true,
        disableFilters: true,
        accessor: 'total',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IPayroll>) => {
            return original.total ? `$${original.total}` : '$0';
        },
        Filter: textFilter<IPayroll>(),
    },*/
    {
        Header: 'Status',
        accessor: 'status',
        disableSortBy: true,
        noDotsRow: true,
        Filter: dropdownFilter<IPayroll>(statusTypes),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IPayroll>) => {
            const valuestatus = statusTypes.find((it) => +it.value === +original.status);

            return valuestatus ? valuestatus.label : '';
        },
    },

    {
        Header: 'Actions',
        accessor: 'updatedAt',
        Cell: (pr) => <PayrollsActionsColumn {...pr} updateState={updateState} setUpdateState={setUpdateState} />,
        disableSortBy: true,
        disableFilters: true,
        width: '20%',
    },
];

const PayrollssGrid: React.FunctionComponent<Props> = ({
    data,
    getData,
    getDataCsv,
    getDataInFile,
    providers,
}: Props) => {
    const [columns, setColumns] = useState<any>([]);
    const [updateState, setUpdateState] = useState<any>(false);

    if (providers.length && !columns.length) {
        setColumns(getColumns(providers, updateState, setUpdateState));
    }

    return (
        <div className={classNames(styles.grid)}>
            <Grid<IPayroll>
                getDataCsv={getDataCsv}
                getDataInFile={getDataInFile}
                columns={columns}
                data={data}
                getData={getData}
            />
        </div>
    );
};

export default PayrollssGrid;
